<template>
  <div class="main-page">
    <div class="container-fluid px-0">
      <aside class="d-md-none">
        <app-bar title="Lupa Kata Sandi" :previousLink="{ name: 'Login' }" />
      </aside>
      <div class="row g-0">
        <div class="col-md-5 d-flex align-items-md-center px-3 px-md-0">
          <div class="form-page w-100">
            <div class="text-center mb-4">
              <router-link to="/">
                <img src="/img/logo.png" alt="Logo Parahita" style="height: 90px;" />
              </router-link>
            </div>
            <div class="group-title mb-4 text-center">
              <span class="title-content-package fw-normal">Lupa Kata Sandi</span> <br />
              <span class="fw-normal fs-12 color-neutral-600">Silahkan masukkan alamat Email / No Telepon anda, kami akan mengirimkan tautan untuk mengatur ulang.</span>
            </div>
            <div class="card login-card">
              <Form @submit="resetPassword">
                <label class="fw-bold">Alamat Email / No Telepon</label>
                <div class="input-group mb-3">
                  <Field
                    type="text"
                    v-model="email"
                    name="email"
                    class="form-control"
                    placeholder="Cth: nama@email.com / 628383xxxxxxx"
                  />
                  <span class="invalid-feedback">{{ errorMessage }}</span>
                  <ErrorMessage name="email" class="invalid-feedback" />
                </div>
                <button
                  class="btn btn-primary w-100 btn-login p-md-3"
                  type="submit"
                  :disabled="loading || !email"
                >
                  {{ loading ? 'Tunggu...' : 'Kirim' }}
                </button>
              </Form>
            </div>
            <div class="d-flex justify-content-center my-3">
              <p class="fw-normal color-neutral-600">
                Ingat kata sandi?
                <router-link to="/login">
                  <span class="fw-bold">Masuk</span>
                </router-link>
              </p>
            </div>
          </div>
        </div>
        <div class="d-none d-md-block col-md-7">
          <div class="frame-image vh-md-100 d-flex align-items-center justify-content-center">
            <div>
              <img src="@/assets/illustration.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/plugins/axios'
import { Field, Form, ErrorMessage } from 'vee-validate'
import AppBar from '@/components/AppBar.vue'
import { title } from '@/core/page'

export default {
  components: {
    Field,
    Form,
    ErrorMessage,
    AppBar
  },
  setup () {
    onMounted(() => {
      nextTick(() => {
        title.value = 'Lupa Password'
      })
    })

    const email = ref('')
    const errorMessage = ref('')
    const router = useRouter()
    const loading = ref(false)

    const resetPassword = async () => {
      try {
        loading.value = true
        const reset = await axios.post('app/lupa_password', {
          email: email.value
        })

        if (reset.data.success === true) {
          router.push({ name: 'SettingPasswordOtp', params: { email: email.value } })
        }
      } catch (error) {
        errorMessage.value = error.response.data.message
      } finally {
        loading.value = false
      }
    }

    return {
      resetPassword,
      email,
      errorMessage,
      loading
    }
  }
}
</script>

<style lang="scss" scoped>
.form-page {
  padding-top: 4rem;

  @media (min-width: 768px) {
    padding-top: 0;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 480px;
    margin: 0 auto;
  }
}

.form-control.is-invalid,
.input-group-text.is-invalid {
  box-shadow: inset 0px -1px 0px #e21f39;
}

.form-control::placeholder {
  color: #cbd5e0;
}

.form-control,
.input-group-text {
  background: none;
  border-radius: 0;
  box-shadow: inset 0px -1px 0px rgba(242, 242, 242, 0.8);
  padding: 8px 4px 8px 0px;
  font-size: 18px;
}

.invalid-feedback {
  display: block;
}

.btn-login {
  border: none;
  padding: 10px 20px;
}

.login-card {
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;

  label {
    font-size: 14px;
    color: #14142b;
  }
}

.frame-image {
  background: #007a9826;
  width: 100%;
  height: 100%;

  @media (min-width: 360px) and (max-width: 767px) {
    position: relative;
    width: 100%;
  }
}
</style>
